export default {"src":"/_next/static/media/google-search-console.12bf03fe.svg","height":2230,"width":2500,"blurWidth":0,"blurHeight":0};